module.exports = __webpack_public_path__ + "img/icon-no-content.23f6db5f.svg";